export default (host: string) => {
  let locationID = null;
  let slug = null;
  
  const config = useRuntimeConfig().public;
  const domain = config.deployDomain;

  const _host = host.split(":")[0];

  if (domain && _host?.endsWith(domain)) {
    const domainParts = _host.split(".");

    if (domainParts.length > 2) {
      slug = domainParts[0];
    }
  }

  if (slug && !isNaN(slug)) {
    locationID = slug;
  }

  if (config.deployForceLocation) {
    locationID = config.deployForceLocation;
  }

  const location: any = {};

  if (locationID) {
    location.id = locationID;
  } else if (slug) {
    location.slug = slug;
    location.domain = domain;
  } else {
    location.host = _host;
  }

  return location;
}